import { render, staticRenderFns } from "./upgradePrizeListAdd.vue?vue&type=template&id=0305acdc&scoped=true&"
import script from "./upgradePrizeListAdd.vue?vue&type=script&lang=js&"
export * from "./upgradePrizeListAdd.vue?vue&type=script&lang=js&"
import style0 from "./upgradePrizeListAdd.vue?vue&type=style&index=0&id=0305acdc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0305acdc",
  null
  
)

export default component.exports